// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"150":"c8f2495b","545":"32783348","551":"a22a53b6","605":"dd6279ae","662":"0c6ac9db","766":"1367ee1a"}[chunkId] + ".chunk.js";
};